import { useQuery } from "@tanstack/react-query";
import { apiListTables } from "../api";

export interface TableSummary {
  room: string;
  gameMode: "tournament" | "cash";
  players: number;
  maxPlayers: number;
  sb: number;
  bb: number;
  phase: string;
  minBuyIn: number;
  maxBuyIn: number;
  startingStack: number;
}

export const useTableLobby = () => {
  return useQuery<TableSummary[]>({
    queryKey: ["tables"],
    queryFn: apiListTables,
    refetchInterval: 5000,
  });
};
